var exports = {
  "iE": "xa15a2ab7--8bf0c1--wrapper",
  "DD": "xa15a2ab7--8bf0c1--title",
  "o3": "xa15a2ab7--8bf0c1--super-agent",
  "s6": "xa15a2ab7--8bf0c1--agent-name",
  "g_": "xa15a2ab7--8bf0c1--proofs",
};

module.exports = exports;
